<template>
  <div class="bannerdiv prelative">
    <div class="index_banner">
      <div class="item" v-for="(banner,index) in banners">
        <div class="items scaleBg" :style="{'background-image': 'url('+banner.image+')'}"></div>
      </div>
    </div>
    <div class="left slick_txt">
      <div class="prev slick_arrow"></div>
    </div>
    <div class="right slick_txt">
      <div class="next slick_arrow"></div>
    </div>
    <div class="number">
      <div class="inner clearfix">
        <span v-for="(banner,index) in banners" :class="{active:index==0}">{{index+1}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../static/slick/slick.css'
import '../../../static/slick/index.css'
import factory from '../../../static/slick/index_slick.js'
import dbanner from '../../../static/slick/index.js'
factory.factory(jQuery);
export default {
  name: "Banner",
  props:[
    'banners'
  ],
  mounted() {

  },
  created() {
    if(this.banners){
      this.initBanner();
    }
  },
  updated() {
    if(this.banners){
      this.initBanner();
    }
    // this.initBanner();
  },
  destroyed() {
  },
  methods:{
    initBanner(){
      this.$nextTick(()=>{
        dbanner.banner();
      })
    }
  },
}
</script>

<style scoped>
.scaleBg{

}
</style>



// WEBPACK FOOTER //
// src/components/index/Banner.vue